<template>
  <div class="full-item">
    <HeadPic></HeadPic>
    <Notices></Notices>
    <Games></Games>
    <Partners></Partners>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import HeadPic from './headPic.vue';
import Notices from './notices.vue';
import Games from './games.vue';
import Partners from './partners.vue';
import Footer from '@/components/footer.vue';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  components: {
    HeadPic,
    Notices,
    Games,
    Partners,
    Footer,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/home/index.vue